import { isMpsContext, type MpsPlayerRole } from './mps-context';

export function vrfStorageKey(room: string, board: number, context: string, role: MpsPlayerRole): string {
  if (!isMpsContext(context)) throw new Error('サイコロcontextが確定していません');
  return `vrf-v2:${JSON.stringify([room, board, context, role])}`;
}
export function vrfProofInput(context: string, round: number, role: MpsPlayerRole): Uint8Array {
  if (!isMpsContext(context) || !Number.isInteger(round) || round < 0) throw new Error('サイコロcontextが不正です');
  return new TextEncoder().encode(`${context}:dice:${round}:${role}`);
}
export function vrfCombineInput(context: string, round: number): Uint8Array {
  if (!isMpsContext(context) || !Number.isInteger(round) || round < 0) throw new Error('サイコロcontextが不正です');
  return new TextEncoder().encode(`${context}:dice:${round}`);
}
export interface StoredVrfPair {secret: number[]; publicKey: number[]}
export function parseStoredVrfPair(raw: string | null): StoredVrfPair | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    const bytes = (part: unknown): part is number[] => Array.isArray(part) && part.length === 32 && part.every(byte => Number.isInteger(byte) && byte >= 0 && byte <= 255);
    return bytes(value.secret) && bytes(value.publicKey) ? {secret: value.secret, publicKey: value.publicKey} : null;
  } catch { return null; }
}
export function sameBytes(first: ArrayLike<number>, second: ArrayLike<number>): boolean { return first.length === second.length && Array.from(first).every((byte, index) => byte === second[index]); }
